import { INSURANCE_FLOW_TYPE } from '../../../constants/insurance-flow-type';

export const checkIsPaperworkFlow = flowType =>
  INSURANCE_FLOW_TYPE.PAPERWORK === flowType;

export const hasPrimarySubscriberData = primarySubscriber =>
  primarySubscriber && Boolean(Object.keys(primarySubscriber).length);



// WEBPACK FOOTER //
// ./src/components/InsurancesInfo/utils/index.js